import {
    START_SPEAKING,
    STOP_SPEAKING,
    MOVE_AVATAR,
    SET_INSTRUCTIONS,
    READY_TO_ANIMATE,
    SET_POST_AUDIO_CALLBACK_NAME,
    SET_OWLY_CAN_SPEAK,
    SET_ANIMATE_ALEX,
} from './avatarActions';
import { UNMOUNT_SCREEN } from '../screen/screenActions';
import {
    postAvatarWRAudioAction,
    WR_PRACTICE_POST_AUDIO_CALLBACK,
} from '../../wr/pages/practice/WRPracticeAvatarActions';

const defaultState = {
    isReadyToAnimate: false,
    isSpeaking: false,
    position: undefined,
    instructions: [],
    postAudioCallback: undefined,
    onTransitionEnd: null,
    canSpeak: true,
    animateAlex: false,
};

const CALLBACK_MAP = {
    [WR_PRACTICE_POST_AUDIO_CALLBACK]: postAvatarWRAudioAction,
};

const avatarReducer = (state = defaultState, action) => {
    switch (action.type) {
        case READY_TO_ANIMATE:
            return {
                ...state,
                isReadyToAnimate: true,
            };
        case START_SPEAKING:
            return {
                ...state,
                isSpeaking: true,
            };
        case STOP_SPEAKING:
            return {
                ...state,
                isSpeaking: false,
            };
        case MOVE_AVATAR:
            return {
                ...state,
                position: action.targetPosition,
                // TODO: use serializable data types
                onTransitionEnd: action.cb,
            };
        case SET_INSTRUCTIONS:
            return {
                ...state,
                instructions: action.instructions,
            };
        case SET_POST_AUDIO_CALLBACK_NAME:
            if (action.postAudioCallback in CALLBACK_MAP) {
                return {
                    ...state,
                    postAudioCallback: action.postAudioCallback,
                };
            }
            throw new Error(
                `Can not set ${action.postAudioCallback} as post audio callback function name, function not mapped`,
            );
        case UNMOUNT_SCREEN:
            return {
                ...state,
                instructions: [],
                isSpeaking: false,
                postAudioCallback: undefined,
            };
        case SET_OWLY_CAN_SPEAK:
            return {
                ...state,
                isSpeaking: false,
                canSpeak: action.payload.canSpeak,
            };
        case SET_ANIMATE_ALEX:
            return {
                ...state,
                animateAlex: action.payload,
            };
        default:
            return state;
    }
};

export default avatarReducer;
